"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Captions = void 0;
const react_1 = __importStar(require("react"));
const Tooltip_1 = __importDefault(require("@material-ui/core/Tooltip"));
const ClosedCaption_1 = __importDefault(require("@material-ui/icons/ClosedCaption"));
const shared_hooks_use_boolean_1 = require("@guidde-co/shared.hooks.use-boolean");
exports.Captions = (0, react_1.memo)(({ videoElement, onClick, initialState = true }) => {
    const activeCC = (0, shared_hooks_use_boolean_1.useBoolean)(initialState);
    // I think it's a temporary change, and this code will be restored.
    // I don't want to remove this code because when it will happen will be much
    // quicker to uncomment it
    /*     const hasCaptions = useBoolean()
const setHasCaptions = hasCaptions.setTrue

useEffect(() => {
    if (!videoElement) return
    const handleLoadCues = (e: Event) => {
        const hasCC = Boolean(
            (e.target as HTMLVideoElement)?.textTracks?.[0]?.cues?.length
        )
        if (hasCC) setHasCaptions()
    }

    videoElement.addEventListener('loadeddata', handleLoadCues)
    return () => {
        videoElement.removeEventListener('loadeddata', handleLoadCues)
    }
}, [videoElement, setHasCaptions])

if (hasCaptions.isFalse) return null */
    return (react_1.default.createElement(Tooltip_1.default, { title: `${activeCC.isTrue ? 'Hide' : 'Show'} subtitles` },
        react_1.default.createElement(ClosedCaption_1.default, { opacity: activeCC.isTrue ? 1 : 0.5, cursor: "pointer", onClick: () => {
                activeCC.toggle();
                onClick === null || onClick === void 0 ? void 0 : onClick();
                if (videoElement === null || videoElement === void 0 ? void 0 : videoElement.textTracks[0]) {
                    videoElement.textTracks[0].mode = activeCC.isTrue
                        ? 'hidden'
                        : 'showing';
                }
            } })));
});
//# sourceMappingURL=captions.js.map